import { Loading } from "components/assets/Icons";
import Button, { SIZE } from "components/Button";
import { useRef } from "react";
import userService from "services/user.service";
import styles from "./Table.module.scss";
import { useSelector } from "react-redux";

const Table = ({
  extensionStatus,
  timetrackingCurrentStatus,
  timetrackingLastStatus,
  setActive,
}) => {
  const ref = useRef("");
  const buttonsRef = useRef([]);

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--thead-height",
        `${ref.current?.offsetHeight}px`
      );
    }
  }

  setHeaderHeight();

  const handleOnUpdate = (requestPath, month, label) => {
    setActive(label);
    buttonsRef?.current.forEach((button) => {
      button.disabled = true;
    });

    userService.runParser(requestPath, month).then(
      () => {},
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        console.error(_content);
      }
    );
  };

  const custom  = useSelector((state) => state.customization);

  return (
    <div className={styles.wrapper}>
      <table className={styles.container}>
        <thead className={styles.header} ref={ref}>
          <tr className={styles.row}>
            <th>Name</th>
            <th>Last Update</th>
            <th>Notes</th>
            <th>Button</th>
          </tr>
        </thead>
        <tbody className={styles.body}>
          <tr>
            <td>{custom.customer_name} System Calls Data</td>
            <td>{extensionStatus?.last_run}</td>
            <td>
              {extensionStatus?.rows_added
                ? `${extensionStatus?.rows_added} rows added`
                : ""}
            </td>
            <td>
              {extensionStatus && (
                <Button
                  type="submit"
                  size={SIZE.SMALL}
                  className={styles.button}
                  disabled={
                    !(
                      extensionStatus?.is_running === "False" &&
                      timetrackingCurrentStatus?.is_running === "False" &&
                      timetrackingLastStatus?.is_running === "False"
                    )
                  }
                  ref={(element) => {
                    buttonsRef.current[0] = element;
                  }}
                  onClick={() =>
                    handleOnUpdate(
                      "parsers/extension_calls/run",
                      "",
                      "extension_calls"
                    )
                  }
                >
                  {extensionStatus?.is_running === "True" ? <Loading /> : ""}
                  Update
                </Button>
              )}
            </td>
          </tr>
          <tr>
            <td>BambooHR Timetracking Data - Current Month</td>
            <td>{timetrackingCurrentStatus?.last_run}</td>
            <td>
              {timetrackingCurrentStatus?.rows_added
                ? `Total: ${timetrackingCurrentStatus?.rows_added} rows`
                : ""}
            </td>
            <td>
              {timetrackingCurrentStatus && (
                <Button
                  type="submit"
                  size={SIZE.SMALL}
                  className={styles.button}
                  disabled={
                    !(
                      extensionStatus?.is_running === "False" &&
                      timetrackingCurrentStatus?.is_running === "False" &&
                      timetrackingLastStatus?.is_running === "False"
                    )
                  }
                  ref={(element) => {
                    buttonsRef.current[1] = element;
                  }}
                  onClick={() =>
                    handleOnUpdate(
                      "parsers/timetracking/run",
                      "this",
                      "timetracking_this"
                    )
                  }
                >
                  {timetrackingCurrentStatus?.is_running === "True" ? (
                    <Loading />
                  ) : (
                    ""
                  )}
                  Update
                </Button>
              )}
            </td>
          </tr>
          <tr>
            <td>BambooHR Timetracking Data - Last Month</td>
            <td>{timetrackingLastStatus?.last_run}</td>
            <td>
              {timetrackingLastStatus?.rows_added
                ? `Total: ${timetrackingLastStatus?.rows_added} rows`
                : ""}
            </td>
            <td>
              {timetrackingLastStatus && (
                <Button
                  type="submit"
                  size={SIZE.SMALL}
                  className={styles.button}
                  disabled={
                    !(
                      extensionStatus?.is_running === "False" &&
                      timetrackingCurrentStatus?.is_running === "False" &&
                      timetrackingLastStatus?.is_running === "False"
                    )
                  }
                  ref={(element) => {
                    buttonsRef.current[2] = element;
                  }}
                  onClick={() =>
                    handleOnUpdate(
                      "parsers/timetracking/run",
                      "previous",
                      "timetracking_previous"
                    )
                  }
                >
                  {timetrackingLastStatus?.is_running === "True" ? (
                    <Loading />
                  ) : (
                    ""
                  )}
                  Update
                </Button>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Table;
